import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const FilterFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M19.17 3.01H4.8c-1.01 0-1.58 1.15-.98 1.96l3.34 4.42L10 13.14v7.4c0 .39.43.6.71.35l2.43-2.19c.25-.22.4-.55.41-.89l.16-4.35 3.09-4.08 3.34-4.42c.61-.81.03-1.96-.98-1.96l.01.01Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default FilterFilled
